"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.propTypes = exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../../ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = exports.propTypes = {
  /**
   * @default 'img'
   */
  bsPrefix: _propTypes.default.string,
  /**
   * Sets image as fluid image.
   */
  fluid: _propTypes.default.bool,
  /**
   * Sets image shape as rounded.
   */
  rounded: _propTypes.default.bool,
  /**
   * Sets image shape as circle.
   */
  roundedCircle: _propTypes.default.bool,
  /**
   * Sets image shape as thumbnail.
   */
  thumbnail: _propTypes.default.bool,
  /**
   * Sets low-res image preview
   */
  preview: _propTypes.default.string,
  /**
   * Missing image fallback graphic
   */
  fallback: _propTypes.default.string,
  /**
   * Define the background color, useful for missing images
   */
  bgColor: _propTypes.default.string
};
const defaultProps = {
  fluid: false,
  rounded: false,
  roundedCircle: false,
  thumbnail: false,
  preview: '',
  fallback: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgAgMAAACmHu77AAAADFBMVEWzs7Pf39/ExMTU1NRdkO0cAAAEDklEQVR4Xu3cIW4bURAG4PVWBVFUmCMEBpb7CAXdtVVZkWGh4cK9hI8S7kuYF+YYBS/NqFK1RpX6b7+hQR+Y7PvHo+mGlRQICAhIQIGAgIBEFggICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICMjULVR/zYHM3VI9xkDGbrHuYiD7ZUgfAzl1y3VNgRxvQM4pkO0NyEMYBAQEBAQEBORh+W+3CwQEBAQE5LV/WQVkqmlcNmSuaVw05FDTuGzIqYZY2ZBLhY9sSI2ssyFjjayzIYcG2cRD9g3Sx0O+dK3iIac3yDUdcnyDnP8RCMi2hj//KQQExH8tH0RPFI/GesZ/WFewmvprLGSYK+oOc3efC9nW93BsovRxUNvg6s+pkLFa5NiWGfNHpm3E9ZQK2f/6iuy6Vi/pPyt8rU3ZPMgftzXvwyG1rfmUDbl07zVHQ9ayizKuBXJYC+S0Fsh2LZA5H1IPlH6OhlSvb56jIfVA+TRMyZAKI5+H4Uc65PI2b9zN2ZDd+5juWzZkrOnW91hI9XpLinMy5FTTreE5ElKsck3BkPm3ZadLIqR6vY/fMq09unRIW0n5GA6pB0o2pHr9nA2pMDJEQ2paugmHVBjJhlSvP6ZDKozkQ1oYyYZUGMmGVK/fhUMqjIRDKoyEQyqMhEMqjGRDKoyEQyqM5EMqjBTEhQEQEBAQEBAQx/ScN/wLBycjT4A6yupMrgvMICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA/AQH02ncA8PdGAAAAAElFTkSuQmCC',
  bgColor: '#dfdfdf'
};
const cclClassName = 'ccl-e-image';
const Image = /*#__PURE__*/_react.default.forwardRef(({
  bsPrefix,
  className,
  fluid,
  rounded,
  roundedCircle,
  thumbnail,
  preview,
  fallback,
  bgColor,
  ...props
}, ref) => {
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'img');
  const cclClassName = 'ccl-e-image';

  // use state for load error
  const [loadError, setLoadError] = (0, _react.useState)(false);

  // 1px x 1px transparent gif
  const spacer = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4xLWMwMDAgNzkuYjBmOGJlOTAsIDIwMjEvMTIvMTUtMjE6MjU6MTUgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMy4yIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlDNDBFN0ZEOUVBMzExRUM5NDlCQzI1OTJFRjA3NTcxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlDNDBFN0ZFOUVBMzExRUM5NDlCQzI1OTJFRjA3NTcxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUM0MEU3RkI5RUEzMTFFQzk0OUJDMjU5MkVGMDc1NzEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUM0MEU3RkM5RUEzMTFFQzk0OUJDMjU5MkVGMDc1NzEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAAAACwAAAAAAQABAAACAkQBADs=';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    // eslint-disable-line jsx-a11y/alt-text
    ref: ref,
    style: loadError ? {
      backgroundImage: `url('${fallback}')`,
      backgroundColor: bgColor,
      height: props.height || '100px',
      width: props.width || '100px'
    } : {
      backgroundImage: preview ? `url('${preview || ''}')` : 'none'
    },
    ...props,
    className: (0, _classnames.default)(className, cclClassName, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`),
    onError: ({
      currentTarget
    }) => {
      setLoadError(true);
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = spacer;
    }
  });
});
Image.displayName = 'Image';
Image.defaultProps = defaultProps;
var _default = exports.default = Image;